import React, { useEffect, useState, useRef } from 'react';
import './tickets.css';
import { supabase } from '../supabase';
import { useNavigate } from 'react-router-dom';

import ttt1 from '../assets/efw1.jpg';
import ttt2 from '../assets/efw2.jpg';
import ttt3 from '../assets/efw3.jpg';
import ttt4 from '../assets/efw4.jpg';
import ttt5 from '../assets/efw5.jpg';
import ttt6 from '../assets/efw6.jpg';

import Nav from '../components/layout/nav';

const imageMap = {
  "efw1.jpg": ttt1,
  "efw2.jpg": ttt2,
  "efw3.jpg": ttt3,
  "efw4.jpg": ttt4,
  "efw5.jpg": ttt5,
  "efw6.jpg": ttt6
};

const getCardStyle = (offset) => {
  const abs = Math.abs(offset);

  if (abs > 3) {
    return { opacity: 0, pointerEvents: 'none' };
  }

  const config = {
    0: { x: 0, y: 0, scale: 1, rot: 0, opacity: 1, z: 10 },
    1: { x: offset < 0 ? -120 : 120, y: 15, scale: 0.85, rot: offset < 0 ? -6 : 6, opacity: 0.7, z: 7 },
    2: { x: offset < 0 ? -160 : 160, y: 35, scale: 0.7, rot: offset < 0 ? -10 : 10, opacity: 0.45, z: 4 },
    3: { x: offset < 0 ? -190 : 190, y: 55, scale: 0.6, rot: offset < 0 ? -14 : 14, opacity: 0.25, z: 1 },
  };

  const c = config[abs];

  return {
    transform: `translate(${c.x}px, ${c.y}px) scale(${c.scale}) rotate(${c.rot}deg)`,
    opacity: c.opacity,
    zIndex: c.z,
  };
};

const Tickets = () => {
  const navigate = useNavigate();

  const [tickets, setTickets] = useState([]);
  const [active, setActive] = useState(0);
  const [counts, setCounts] = useState({});

  const touchY = useRef(null);
  const scrollLock = useRef(false);

  useEffect(() => {
    const fetchTickets = async () => {
      const { data } = await supabase.from('tickets').select('*');

      if (data) {
        setTickets(data);
        setCounts(Object.fromEntries(data.map(t => [t.id, 1])));
      }
    };

    fetchTickets();
  }, []);

  const increase = (id) =>
    setCounts(prev => ({ ...prev, [id]: (prev[id] || 1) + 1 }));

  const decrease = (id) =>
    setCounts(prev => ({ ...prev, [id]: Math.max(1, (prev[id] || 1) - 1) }));

  const goTo = (i) => {
    if (i < 0 || i >= tickets.length) return;
    setActive(i);
  };

  const handleWheel = (e) => {
    if (scrollLock.current) return;
    scrollLock.current = true;

    setTimeout(() => (scrollLock.current = false), 500);

    goTo(active + (e.deltaY > 0 ? 1 : -1));
  };

  const handleTouchStart = (e) => {
    touchY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    if (!touchY.current) return;

    const diff = touchY.current - e.changedTouches[0].clientY;

    if (Math.abs(diff) > 40) {
      goTo(active + (diff > 0 ? 1 : -1));
    }

    touchY.current = null;
  };

  if (!tickets.length) return null;

  return (
    <div className="hcontainer designerspage">
      <div className="homee ticketsbg">

        <div className="tictitlediv">
          <div className="dtitlepage">
            <h5 className="h5m">Tickets</h5>
            <h6 className="desdess">
              Secure Your Fashion Week Experience
            </h6>
          </div>

          <div className="searchhome">
            <div className="searchicon"></div>
            <h6 className="searchtextt">Search designers...</h6>
          </div>
        </div>

        <div
          className="ticketsdiv1"
          onWheel={handleWheel}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="ticketsunion">

            {tickets.map((t, i) => {
              const offset = i - active;
              const style = getCardStyle(offset);

              const img = imageMap[t.image?.trim()];

              return (
                <div
                  key={t.id}
                  className="ticketcard"
                  style={style}
                  onClick={() => goTo(i)}
                >
                  <img
                    src={img || ttt1}
                    className="ticketimg"
                    alt={t.title}
                  />

                  <h3>{t.title}</h3>
                  <p>{t.description}</p>

                  <div className="features">
                    {t.features?.map((f, idx) => (
                      <span key={idx}>• {f}</span>
                    ))}
                  </div>

                  <div className="pricerow">
                    <h2>{t.price}</h2>

                    <div className="counter">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          decrease(t.id);
                        }}
                      >
                        -
                      </button>

                      <span>{counts[t.id]}</span>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          increase(t.id);
                        }}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <button
                    className="buybtn"
                    onClick={(e) => {
                      e.stopPropagation();

                      navigate('/booking', {
                        state: {
                          ticket: {
                            ...t,
                            image: img || ttt1 
                          },
                          quantity: counts[t.id] || 1
                        }
                      });
                    }}
                  >
                    BOOK NOW
                  </button>

                </div>
              );
            })}

          </div>
        </div>

        <Nav />
      </div>
    </div>
  );
};

export default Tickets;